import * as React from "react";
import { forwardRef } from "react";
const SvgBlueCheckmark = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 56, height: 56, viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M18.08 29.6614L24.052 35.6476L37.92 20.3521", stroke: "#3662FF", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("rect", { x: 2, y: 2, width: 52, height: 52, rx: 26, stroke: "#3662FF", strokeWidth: 3 }));
const ForwardRef = forwardRef(SvgBlueCheckmark);
export { ForwardRef as ReactComponent };
